import React, {Component} from 'react';
import {
    StyleSheet,
    Text,
    View, processColor, Platform
} from 'react-native';

import {Tools} from "../../tools/Tools";
import {moderateScale} from "../../tools/Scaling";
import * as Colors from "../../tools/Colors";
import {typeExport} from "../../redux/store/type";
import {Bar} from "@reactchartjs/react-chart.js";
import HMTextView from "../HMTextView";

const options = {
    /* tooltip:{
         bodyFontSize:moderateScale(100),

     },*/
    legend: {
        labels: {
            usePointStyle: true,
            boxWidth: moderateScale(6)
        }
    },
    maintainAspectRatio: false,
    scaleShowValues: true,

    scales: {
        yAxes: [
            {
                ticks: {
                    beginAtZero: true,
                    fontColor: Colors.blackLight,
                    fontFamily: typeExport.regularFontName,
                    fontSize: moderateScale(14),
                    fontStyle: "bold"
                },
            },
        ],
        xAxes: [{
            /*     fontFamily: i18n.locale == 'en' ? typeExport.regularFontName : typeExport.regularFontName,
                 fontWeight:"bold",

                 //   fontFamily: "IRANSansMobile(FaNum)_Bold",

                 //valueFormatter: ['1990', '1991', '1992', '1993', '1994'],

                 textSize:1000,
                 granularityEnabled: true,
                 granularity: 1,
                 axisMaximum: 3,
                 axisMinimum: 0,
                 centerAxisLabels: true,
                 position:"BOTTOM",*/
            ticks: {
                autoSkip: false,
                fontColor: Colors.blackLight,
                fontFamily: typeExport.regularFontName,
                fontSize: moderateScale(14),
                fontStyle: "bold"
            }
        }]
    },
}
export default class HMGroupBarChart extends Component {
    constructor(props) {
        super(props);
        let item = props.item;
        let myService = props.myService;

        /*        let item =[
                    {
                        "NAME": "INTERNET",
                        "FNAME": "اینترنت بین الملل",
                        "IN": 5659874562,
                        "OUT": 15987453214,
                        "CREDITUSED": 125645,
                        "URL": ""
                    },
                    {
                        "NAME": "INTERNAL",
                        "FNAME": "سایت های داخلی",
                        "IN": 12548963584,
                        "OUT": 1358745699,
                        "CREDITUSED": 266412,
                        "URL": "https:\/\/icip.ito.gov.ir\/index.php\/site\/page\/view\/list_ip"
                    },
                    {
                        "NAME": "VOD",
                        "FNAME": "تلویزیون اینترنتی",
                        "IN": 28656487543,
                        "OUT": 3258457896,
                        "CREDITUSED": 125874,
                        "URL": "https:\/\/icip.ito.gov.ir\/index.php\/site\/page\/view\/list_ip"
                    },
                    {
                        "NAME": "SATIA",
                        "FNAME": "رایگانها",
                        "IN": 895656456,
                        "OUT": 655646,
                        "CREDITUSED": 148759,
                        "URL": ""
                    },
                    {
                        "NAME": "MESSENGER",
                        "FNAME": "پیام رسان داخلی",
                        "IN": 64645655,
                        "OUT": 0,
                        "CREDITUSED": 64587,
                        "URL": ""
                    }
                ];*/

        let arr = [];
        let arrayX = [];
        // let arrayX = [];

        let arrayA = [];
        let arrayB = [];
        let arrayC = [];
        let arrayD = [];

        for (let i = 0; i < item.length; i++) {
            //let arrayY = [];
            arrayA.push(Tools.convertOnlyGig(item[i].OUT))
            arrayB.push(Tools.convertOnlyGig(item[i].IN))
            arrayC.push(Tools.convertOnlyGig(item[i].OUT + item[i].IN, myService))
            arrayD.push(Tools.M_convertOnlyGig(item[i].CREDITUSED, myService))

            arrayX.push(Tools.SubString(item[i].FNAME ? item[i].FNAME : item[i].MONTH, 20))
            // arrayX.push(item[i].FNAME)
            //  arr.push({
            //      y: arrayY,
            //      marker: ["ارسال", "دریافت"]
            //  })
        }

        /*   let arrayData=[
            //    {
            //     values: arrayA,
            //     label: 'ارسال',
            //     config: {
            //         drawValues: false,
            //         colors: [processColor('#009bee')],
            //     }
            // }, {
            //     values: arrayB,
            //     label: 'دریافت',
            //     config: {
            //         drawValues: false,
            //         colors: [processColor('#ee5a5d')],
            //     }
            // },
               {
                values: arrayC,
                label: 'ترافیک مصرفی',
                config: {
                    drawValues: false,
                    colors: [processColor('#00c218')],
                }
            }, {
                values: arrayD,
                label: 'اعتبار مصرفی',
                config: {
                    drawValues: false,
                    colors: [processColor('#c20080')],
                }
            }]*/

        let type = "bold";
        this.state = {
            dataBar: {
                labels: arrayX,
                datasets: [
                    {
                        label: 'ترافیک مصرفی',
                        data: arrayC,
                        backgroundColor: '#00c218',
                    },
                    {
                        label: 'اعتبار مصرفی',
                        data: arrayD,
                        backgroundColor: '#c20080',
                    },
                    /*      {
                              label: '# of Green Votes',
                              data: [3, 10, 13, 15, 22, 30],
                              backgroundColor: 'rgb(75, 192, 192)',
                          },*/
                ],
            },


            legend: {
                enabled: true,
                textSize: 14,
                form: "SQUARE",
                formSize: 14,
                xEntrySpace: 10,
                yEntrySpace: 5,
                wordWrapEnabled: true,
                fontFamily: typeExport.regularFontName,

                //fontWeight: Platform.OS === "ios" ? (type === "bold" ? "700" : (type === "light" ? "300" : "400")) : null,
/////////////
                //  formToTextSpace: 5,
                //maxSizePercent: 0.5,
                textColor: processColor('blue'),
                // position: 'BELOW_CHART_LEFT',

            },
            /*      data: {
                      dataSets: arrayData

                      //     [{
                      //     values: [5, 40, 77, 81, 43],
                      //     label: 'ارسال',
                      //     config: {
                      //         drawValues: false,
                      //         colors: [processColor('red')],
                      //     }
                      // }, {
                      //     values: [40, 5, 50, 23, 79],
                      //     label: 'دریافت',
                      //     config: {
                      //         drawValues: false,
                      //         colors: [processColor('blue')],
                      //     }
                      // }, {
                      //     values: [10, 55, 35, 90, 82],
                      //     label: 'اعتبار مصرفی',
                      //     config: {
                      //         drawValues: false,
                      //         colors: [processColor('green')],
                      //     }
                      // }]
                      ,
                     // 2
                      config: {
                          barWidth: 0.31,
                          group: {
                              fromX: 0,
                              groupSpace: 0.12,
                              barSpace: 0.13,
                          },


                      }

                      //3
                      // config: {
                      //     barWidth: 0.2,
                      //     group: {
                      //         fromX: 0,
                      //         groupSpace: 0.1,
                      //         barSpace: 0.1,
                      //     },
                      // }
                      //4
                      // config: {
                      //     barWidth: 0.16,
                      //     group: {
                      //         fromX: 0,
                      //         groupSpace: 0.08,
                      //         barSpace: 0.07,
                      //     },
                      // }
                  },*/
            /*      xAxis: {
                      fontFamily: i18n.locale == 'en' ? typeExport.regularFontName : typeExport.regularFontName,
       fontWeight:"bold",

                      //   fontFamily: "IRANSansMobile(FaNum)_Bold",

                      //valueFormatter: ['1990', '1991', '1992', '1993', '1994'],

                valueFormatter: arrayX,
                      textSize:moderateScale(48/item.length),
                      granularityEnabled: true,
                      granularity: 1,
                      axisMaximum: item.length,
                      axisMinimum: 0,
                      centerAxisLabels: true,
                      position:"BOTTOM",



                  },*/
            /*        yAxis: {
                        //spaceBottom:moderateScale(1),
                      left: {
                          //fontFamily: "IRANSansMobile(FaNum)_Bold",
                          fontFamily: i18n.locale == 'en' ? typeExport.regularFontName : typeExport.regularFontName,

                          axisLineColor: processColor(Colors.colorSecondPrimary),
                            gridColor: processColor(Colors.colorPrimary),
                            // labelCount:      6,
                            labelCountForce: true,
                            textSize:14,
                          axisMinimum: 0,

                        },
                        right: {
                            fontFamily: i18n.locale == 'en' ? typeExport.regularFontName : typeExport.regularFontName,

                            //   fontFamily: "IRANSansMobile(FaNum)_Bold",

                            enabled: false,
                            drawLabels: true,
                            drawAxisLine: true,
                            axisLineColor: processColor(Colors.colorPrimaryDark),
                            drawGridLines: false,
                        }
                    },*/
            /*            marker: {
                            enabled: true,
                            //fontFamily: "IRANSansMobile(FaNum)_Bold",

                            fontFamily: i18n.locale == 'en' ? typeExport.regularFontName : typeExport.regularFontName,
                          //  fontWeight: Platform.OS === "ios" ? (type === "bold" ? "700" : (type === "light" ? "300" : "400")) : null,
                            markerColor: processColor('#F0C0FF8C'),
                            textColor: processColor(Colors.blackLight),
                            markerFontSize: 14,
                        },*/

        };
    }

    componentDidMount() {
        // in this example, there are line, bar, candle, scatter, bubble in this combined chart.
        // according to MpAndroidChart, the default data sequence is line, bar, scatter, candle, bubble.
        // so 4 should be used as dataIndex to highlight bubble data.

        // if there is only bar, bubble in this combined chart.
        // 1 should be used as dataIndex to highlight bubble data.

        this.setState({
            ...this.state,
            //     highlights: [{x: 1, y:40}, {x: 2, y:50}]

        })
    }

    handleSelect(event) {
        let entry = event.nativeEvent
        if (entry == null) {
            this.setState({...this.state, selectedEntry: null})
        } else {
            this.setState({...this.state, selectedEntry: JSON.stringify(entry)})
        }

    }

    render() {
        let {title, styleTitle, styleRootTitle} = this.props;

        return (
            <View style={{flex: 1}}>

                {/*<View style={{height:80}}>*/}
                {/*<Text> selected entry</Text>*/}
                {/*<Text> {this.state.selectedEntry}</Text>*/}
                {/*</View>*/}

                <View style={styles.container}>
                    {title ?
                        <HMTextView
                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                            text={title}
                            //  text={"ثبت و بستن تیکت"}
                            type={"bold"}
                            style={[{
                                fontSize: moderateScale(16),
                                marginVertical: moderateScale(2),
                                //     marginHorizontal: moderateScale(4),
                                color: Colors.blackLight
                            }, styleTitle]}
                            styleRoot={[{alignSelf: "center"}, styleRootTitle]}
                        />
                        :
                        null
                    }
                    {/*    <BarChart



                        style={styles.chart}
                        xAxis={this.state.xAxis}
                        yAxis={this.state.yAxis}
                        chartDescription={{text: ''}}

                        data={this.state.data}
                        legend={this.state.legend}
                        drawValueAboveBar={false}
                        onSelect={this.handleSelect.bind(this)}
                        onChange={(event) => {}}
                        highlights={this.state.highlights}
                        marker={this.state.marker}
                        extraOffsets={{left:moderateScale(1), right:moderateScale(1), top: moderateScale(1), bottom: moderateScale(12)}}

                    />*/}


                    <Bar
                        data={this.props.dataChart ? this.props.dataChart : this.state.dataBar}
                        options={options}
                        //width={"100%"}
                        // height={"100%"}
                    />

                </View>

            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#F5FCFF',
        paddingVertical: moderateScale(10),
        paddingHorizontal: moderateScale(4)
    },
    chart: {
        flex: 1
    }
});
